import React, { ReactNode } from 'react';

import * as styles from './listing-page-row-name-cell.scss';

interface ListingPageRowNameCellProps {
  name: ReactNode;
  onNameClick: () => void;
  disabled?: boolean;
  subtext?: ReactNode;
  pill?: ReactNode;
}

export const ListingPageRowNameCell = ({
  name,
  onNameClick,
  disabled = false,
  subtext,
  pill
}: ListingPageRowNameCellProps) => (
  <>
    <button type="button" className={styles.reportName} onClick={onNameClick} disabled={disabled}>
      {name}
    </button>
    {subtext && <span className={styles.reportNameSubText}>{subtext}</span>}
    {pill && <div>{pill}</div>}
  </>
);
